import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { TPagination } from "@/types/api";

type TLearnerPlanListTopProps = {
  pagination?: TPagination;
};

export const LearnerPlanListTop: FC<TLearnerPlanListTopProps> = ({ pagination }) => {
  const total = pagination?.total ?? 0;
  const displayed = pagination?.count ?? 0;

  return (
    <Box marginBottom={2} display="flex" justifyContent="space-between" alignItems="center">
      <Typography variant="body14Semi">
        全 {total.toLocaleString("en-US")} 件中 {displayed} 件を表示
      </Typography>
    </Box>
  );
};
